import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { HandoverStatusMetadata } from "@common/ADAPT.Common.Model/organisation/handover-status";
import { RoleConnection } from "@common/ADAPT.Common.Model/organisation/role-connection";

@Component({
    selector: "adapt-display-role-connection-handover-status",
    standalone: false,
    templateUrl: "./display-role-connection-handover-status.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: `:host { display: contents; }`,
})
export class DisplayRoleConnectionHandoverStatusComponent {
    @Input() public roleConnection?: RoleConnection;

    public get handoverStatusMetadata() {
        if (!this.roleConnection?.handoverStatus) {
            return undefined;
        }

        return HandoverStatusMetadata.ByStatus[this.roleConnection.handoverStatus];
    }
}
